export default __webpack_public_path__ + "static/media/sticker-o.5254f154.png";